module.exports = "<div class=\"jumbotron-container\">\n    <div class=\"jumbotron-content\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"jumbotron-image\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/jumbotron/jumbotron.component.html
// module id = 854
// module chunks = 0